import { palette } from "../../theme/palette";
import { View } from "../View";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  container: {
    display: "inline-block",
    flexDirection: "row",
    margin: "0px 5px",
  },
  left: {
    fontWeight: "bold",
    display: "inline",
    color: palette.typography.white.solid,
  },
  right: {
    fontWeight: "400",
    display: "inline",
    color: palette.typography.white.medium,
  },
}));

const KeyValue = ({ property, value }) => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      <View className={styles.left}>{property}:</View>
      <View className={styles.right}>{` ${value}`}</View>
    </View>
  );
};

export default KeyValue;
